import type { TourRouteLocation } from '@/components/ui/TourRouteMap';

export type LatLngLiteral = { lat: number; lng: number };

export function locationsFingerprint(locations: TourRouteLocation[]): string {
    return locations
        .map((l) => [
            l.lat ?? '',
            l.lng ?? '',
            l.location_address ?? '',
            l.day_id ?? '',
            l.order_index ?? '',
        ].join(','))
        .join('|');
}

/** İki nokta arasında spherical interpolasyon (Google Maps geometry). */
export function interpolateSegment(
    from: LatLngLiteral,
    to: LatLngLiteral,
    steps: number,
): LatLngLiteral[] {
    const spherical =
        typeof window !== 'undefined' ? window.google?.maps?.geometry?.spherical : undefined;
    if (!spherical?.interpolate || steps < 1) {
        return [from, to];
    }

    const points: LatLngLiteral[] = [];
    for (let i = 0; i <= steps; i++) {
        const fraction = i / steps;
        const point = spherical.interpolate(from, to, fraction);
        points.push(normalizeLatLng(point));
    }
    return points;
}

type GoogleLatLngLike = LatLngLiteral | { lat: () => number; lng: () => number };

function normalizeLatLng(point: GoogleLatLngLike): LatLngLiteral {
    if (typeof (point as { lat?: unknown }).lat === 'function') {
        const p = point as { lat: () => number; lng: () => number };
        return { lat: p.lat(), lng: p.lng() };
    }
    return point as LatLngLiteral;
}

export function segmentStepCount(from: LatLngLiteral, to: LatLngLiteral): number {
    const compute =
        typeof window !== 'undefined'
            ? window.google?.maps?.geometry?.spherical?.computeDistanceBetween
            : undefined;
    if (!compute) return 50;
    const meters = compute(from, to);
    return Math.min(120, Math.max(30, Math.round(meters / 800)));
}
